import React, { useEffect } from 'react';
import { Table, Typography, Card, Row, Col, Divider, Button } from 'antd';
import { financialSummaryData } from '../../data/sampleData';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const FinancialSummary = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        navigate('/reports');
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [navigate]);

  const columns = [
    { title: 'Month', dataIndex: 'month', key: 'month' },
    {
      title: 'Income (₹)', dataIndex: 'income', key: 'income',
      render: val => `₹${val.toLocaleString()}`
    },
    {
      title: 'Expense (₹)', dataIndex: 'expense', key: 'expense',
      render: val => `₹${val.toLocaleString()}`
    },
    {
      title: 'Profit (₹)', dataIndex: 'profit', key: 'profit',
      render: val => `₹${val.toLocaleString()}`
    },
  ];

  return (
    <Row justify="center" style={{ padding: '24px' }}>
      <Col span={24} md={20} lg={16}>
        <Button
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/reports')}
          style={{ marginBottom: 16 }}
        >
          Back
        </Button>
        <Card
          title={<Title level={3} style={{ marginBottom: 0 }}>📈 Financial Summary</Title>}
          bordered={false}
          style={{ boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}
        >
          <Text type="secondary">Monthly income, expenses, and profits</Text>
          <Divider />
          <Table
            dataSource={financialSummaryData}
            columns={columns}
            rowKey="month"
            pagination={{ pageSize: 5 }}
            bordered
          />
        </Card>
      </Col>
    </Row>
  );
};

export default FinancialSummary;
